// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__J7Bdu","reportModal":"styles_reportModal__yhIrZ","paramsBlock":"styles_paramsBlock__0uCZ7","buttonsBlock":"styles_buttonsBlock__P6QtN"};